import { apiClient } from './client';

export const childApi = {
  getAll:          (params)   => apiClient.get('/children', { params }),
  getById:         (id)       => apiClient.get(`/children/${id}`),
  search:          (q)        => apiClient.get('/children/search', { params: { q } }),
  getByParentPhone:(phone)    => apiClient.get('/children/by-phone', { params: { phone } }),
  create:          (data)     => data instanceof FormData
    ? apiClient.post('/children', data, { headers: { 'Content-Type': 'multipart/form-data' } })
    : apiClient.post('/children', data),
  update:          (id, data) => data instanceof FormData
    ? apiClient.put(`/children/${id}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
    : apiClient.put(`/children/${id}`, data),
  delete:          (id)       => apiClient.delete(`/children/${id}`),
  importExcel:     (formData) => apiClient.post('/children/import-excel', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
};
